import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir,search,plant,year) {
    return httpsFile().get(`stock_card?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}&year=${year}`);
}
export function getBegBal(page, currentpage,sortby,sortdir,search,plant,year) {
    return httpsFile().get(`getBegBal?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}&year=${year}`);
}

export function stock_card_show(page, currentpage,sortby,sortdir,startDate,endDate,plant,lgort,matnr,trans_type,year,search,showTotals,selectedDate){
    return https().get(`stock_card_show?page=${page}&currentpage=${currentpage}
    &sortby=${sortby}&sortdir=${sortdir}&startDate=${startDate}&endDate=${endDate}&plant=${plant}&lgort=${lgort}&matnr=${matnr}&trans_type=${trans_type}&year=${year}
    &search=${search}&showTotals=${showTotals}&selectedDate=${selectedDate}`);
}
//
// export function showReceivingReport(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate) {
//     return httpsFile().get(`showReceivingReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}`);
// }
//
// export function showReceivingReportDetails(id){
//     return https().get(`showReceivingReport/${id}`);
// }
//
export function upload_begbal(data){
    return https().post(`upload_begbal`,data);
}
//
// export function getDelivered(MATNR,EBELN,EBELP){
//     return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
// }
// export function getStatus(EBELN){
//     return https().get(`getStatus?EBELN=${EBELN}`);
// }
//
// export function getRequestedQty(MATNR,EBELN){
//     return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
// }


// export function saveReceivingReport(data){
//     return https().post(`saveReceivingReport`,data);
// }